import { ActionTypes } from "../../constants/ActionTypes";

export const fetchStart = () => {
  return {
    type: ActionTypes.FETCH_START,
  };
};

export const fetchSuccess = () => {
  return {
    type: ActionTypes.FETCH_SUCCESS,
  };
};

export const fetchError = (error: any) => {

  return {
    type: ActionTypes.FETCH_ERROR,
    payload: error,
  };
};

export const showMessage = (message: string) => {
  return {
    type: ActionTypes.SHOW_MESSAGE,
    payload: message,
  };
};

export const hideMessage = () => {
  return {
    type: ActionTypes.HIDE_MESSAGE,
  };
};
